import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';
//

// ----------------------------------------------------------------------

export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow, projectId }) {
    const { equipment_code, name, operating_cost, unit, unit_price, quantity, own_cost, rental_cost, hours } = row;
    console.log(row, '=======================')
    const confirm = useBoolean();
    const quickEdit = useBoolean();
    const popover = usePopover();
    return (
        <>
            <TableRow hover selected={ selected }>
                <TableCell padding="checkbox">
                    <Checkbox checked={ selected } onClick={ onSelectRow } />
                </TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ equipment_code }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ name }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ quantity }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ unit }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ unit_price }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ hours }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ rental_cost }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ own_cost }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ operating_cost }</TableCell>
                <TableCell align="right" sx={ { whiteSpace: 'nowrap' } }>
                    <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ popover.onOpen }>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </TableCell>
            </TableRow>
            <CustomPopover
                open={ popover.open }
                onClose={ popover.onClose }
                arrow="right-top"
                sx={ { width: 140 } }
            >
                <MenuItem
                    onClick={ () => {
                        confirm.onTrue();
                        popover.onClose();
                    } }
                    sx={ { color: 'error.main' } }
                >
                    <Iconify icon="solar:trash-bin-trash-bold" />
                    Delete
                </MenuItem>

                <MenuItem
                    onClick={ () => {
                        onEditRow();
                        popover.onClose();
                    } }
                >
                    <Iconify icon="solar:pen-bold" />
                    Edit
                </MenuItem>
            </CustomPopover>

            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content="Are you sure want to delete?"
                action={
                    <Button variant="contained" onClick={ onDeleteRow }>
                        Delete
                    </Button>
                }
            />
        </>
    );
}
UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object,
    selected: PropTypes.bool,
};